import React from "react";
import { Activity } from "lucide-react";
import type { AuditLogEntry } from "../../../types/audit";

type ActivityTabProps = {
  logs: AuditLogEntry[];
  loading: boolean;
};

const getActionLabel = (action: string): string => {
  const actionLabels: Record<string, string> = {
    request_created: "Request Created",
    request_create: "Request Created",
    request_viewed: "Request Viewed",
    request_signed: "Document Signed",
    request_submitted: "Form Submitted",
    request_canceled: "Request Canceled",
    request_cancel: "Request Canceled",
    request_update: "Request Updated",
    reminder_sent: "Reminder Sent",
    invitation_sent: "Invitation Sent",
    invitation_resent: "Invitation Resent",
    participant_added: "Participant Added",
    participant_removed: "Participant Removed",
    form_submitted: "Form Submitted",
  };
  return actionLabels[action] || action.replace(/_/g, " ");
};

export const ActivityTab: React.FC<ActivityTabProps> = ({ logs, loading }) => {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-semibold text-black dark:text-white">
        Activity Log
      </h3>

      {loading ? (
        <div className="flex justify-center py-8">
          <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-600 border-t-transparent"></div>
        </div>
      ) : logs.length > 0 ? (
        <div className="space-y-3">
          {logs.map((log) => (
            <div
              key={log.id}
              className="flex items-start gap-4 p-4 bg-gray-50 dark:bg-gray-800 rounded-lg"
            >
              <div className="p-2 rounded-lg bg-white dark:bg-gray-700">
                <Activity size={16} className="text-gray-500" />
              </div>
              <div className="flex-1">
                <p className="font-medium text-black dark:text-white">
                  {getActionLabel(log.action)}
                </p>
                <p className="text-sm text-gray-500">
                  {log.userFullName || log.userEmail || "System"} •{" "}
                  {new Date(log.createdAt).toLocaleString()}
                </p>
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500">
          No activity recorded for this request
        </div>
      )}
    </div>
  );
};
